import styles from "./PasswordInput.module.css"
import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { useTranslation } from "react-i18next";
/**
* Props for the PasswordInput component.
*/ 
interface PasswordInputProps {
    text?: string, // Label
    onChange?: (value: string) => void, // Change event handler
    password?: string // Current value
}
/**
* A password input component with optional label.
*
* @param props PasswordInput props
* @param {string} props.text - Label
* @param {(value: string) => void} props.onChange - Change event handler
* @param {string} props.password - Current value
* @returns TSX.Element
*/
const PasswordInput: React.FC<PasswordInputProps> = ({ text = "" , onChange, password}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false) // Password visible flag
    const { t } = useTranslation(); // Translation
    if (text === "") text = t("inputs.password"); // Password placeholder
    return(
        <>
        <div className={styles.PasswordInputBlock}>
            <div className={styles.PasswordInputCenter}>
                <div className={styles.PasswordInputIcon}>
                    <Lock />
                </div>
                <input type={isVisible ? "text" : "password"} className={styles.PasswordInputField} 
                onChange={(e)=>onChange && onChange(e.target.value)}
                value={password}
                />
                <button type="button" className={styles.PasswordVisibilityButton} onClick={()=>setIsVisible(!isVisible)}>
                    {isVisible ? <EyeOff/> : <Eye/>}
                </button>
            </div>
            <div className={styles.PasswordInputLabel}><p>{text}</p></div>
            <div className={styles.PasswordInputTooltip}></div>
        </div>
        </>
    )
};
export default PasswordInput;